import React from "react"
import CustomTextInput from "../../../../../ui/atoms/CustomTextInput"
import MenuListItem from "../../../../../ui/molecules/Menu/MenuList/MenuListItem"
import { jsonClone } from "../../../../../utils/json"
import { expandTreeOptions } from "../../../converters/filters"
import CheckboxFilterItem from "../CheckboxFilterItem"
import {
  CheckboxFilterOption,
  FilterCategory,
  FilterCategoryOptions,
} from "../types"

interface Props {
  item: FilterCategory
  parent?: CheckboxFilterOption
  onItemUpdate: (item: FilterCategory) => void
  onOptionExpand?: (item: CheckboxFilterOption) => void
  className?: string
  maxScrollItems?: number
  minTextFilterItems?: number
}

const castOptions = (options?: FilterCategoryOptions): CheckboxFilterOption[] =>
  (options as CheckboxFilterOption[]) ?? []

const filterOptions = (options: CheckboxFilterOption[], text: string) =>
  options.filter((x) => x.label.toLowerCase().indexOf(text.toLowerCase()) >= 0)

const getCurrentOptions = (
  item: FilterCategory,
  parent?: CheckboxFilterOption
) => {
  if (!parent) {
    return castOptions(item?.options)
    // skip root tree level if it has one node only
    // if (options.length === 1 && (options[0].children?.length ?? 0) > 0) {
    //   const allOptions = expandTreeOptions(castOptions(item?.options))
    //   return allOptions.filter((x) => x.parent?.value === options[0].parent)
    // }
  }

  const allOptions = expandTreeOptions(castOptions(item?.options))
  return allOptions.filter((x) => x.parent?.value === parent?.value)
}

const CheckboxFilterCategory = ({
  item,
  parent,
  onItemUpdate,
  onOptionExpand,
  className,
  maxScrollItems,
  minTextFilterItems,
}: Props) => {
  const options = getCurrentOptions(item, parent)
  const [text, setText] = React.useState("")

  const toggleOption = (option: CheckboxFilterOption) => {
    const updatedCategory = jsonClone(item) as FilterCategory
    const options = expandTreeOptions(castOptions(updatedCategory.options))
    const index = options.findIndex((x) => x.value === option.value)
    options[index].selected = !options[index].selected

    onItemUpdate(updatedCategory)
  }

  return (
    <div className={className}>
      {minTextFilterItems && options.length >= minTextFilterItems && (
        <div className="mb-2">
          <CustomTextInput value={text} onChange={setText} label="Filtra" />
        </div>
      )}
      <div
        style={{
          maxHeight: maxScrollItems ? maxScrollItems * 36 : undefined,
          overflow: "auto",
        }}
      >
        {filterOptions(options, text).map(
          (option: CheckboxFilterOption, index: number) => (
            <div key={`${index}-${option.label}`}>
              {option.children && option.children.length > 0 ? (
                <MenuListItem
                  item={{
                    content: `${option.label} (${option.occurrences})`,
                    onItemClick: () =>
                      option.customAction
                        ? option.customAction()
                        : onOptionExpand?.(option),
                  }}
                  bottomBorder
                />
              ) : (
                <CheckboxFilterItem
                  option={option}
                  selected={option.selected}
                  onClick={() => toggleOption(option)}
                  className="pl-3 mt-3 mb-1 sm:my-1 sm:pl-0"
                />
              )}
            </div>
          )
        )}
      </div>
    </div>
  )
}

export default CheckboxFilterCategory
